if (!customElements.get("td-product-form")) {
  class TdProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      this.submitButton = this.querySelector("[data-atc-button]");
      this.sampleButton = this.querySelector("[data-sample-atc-button]");
      this.spinner = this.querySelector(".loading__spinner");
      this.quantity = 1;
      this.groutCrossSellCheckbox = this.querySelector(".td-product__grout-cross-sell__wrap input[type='checkbox']");
      this.groutCrossSellId = this.querySelector(".td-product__grout-cross-sell__wrap")?.dataset.groutCrossSellId;
      this.groutQuantity = 0;
      this.totalGroutPrice = 0;

      this.overageWarning = document.querySelector("[data-overage-warning]");

      this.hideErrors = this.dataset.hideErrors === "true";
      this.errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessageWrapper?.querySelector('.product-form__error-message');
    }

    connectedCallback() {
      if (this.form) {
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.form.addEventListener("change", this.updateATC.bind(this));
      }

      if (this.sampleButton) {
        this.sampleButton.addEventListener("click", (evt) =>
          this.handleAddToCart(evt, {
            id: this.sampleButton.dataset.sampleProductId,
            quantity: 1,
            button: this.sampleButton,
          }, true)
        );
      }

      const crossSellWrapper = document.querySelectorAll('.td-product__cs--wrapper');
      crossSellWrapper.forEach((crossSellElement) => {
        crossSellElement.addEventListener('click', (evt) => {
          this.handleCrossSellAddToCart(evt, crossSellElement);
        });
      });
      

      window.addEventListener("total-boxes-updated", this.onUpdateTotalBoxes.bind(this));
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors || !this.errorMessageWrapper) return;

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    handleAddToCart(evt, { id, quantity, button }, isSample = false) {
      evt.preventDefault();
      if (!id) return;

      this.continueAddToCart = () => {
        const formData = {
          items: [{ id, quantity }],
        };
  
        if (this.groutCrossSellCheckbox && this.groutCrossSellCheckbox.checked && this.groutCrossSellId && button === this.submitButton) {
          formData.items.push({
            id: this.groutCrossSellId,
            quantity: this.groutQuantity,
          });
        }
  
        if (this.cart) {
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
  
        button.setAttribute("aria-disabled", true);
        button.classList.add("loading");
        this.spinner?.classList.remove("hidden");
  
        
  
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.message || "An error occurred. Please try again.");
              return;
            }
  
            this.handleErrorMessage(); 
  
            if (this.cart) {
              this.cart.renderContents(response);
            }
          })
          .catch((error) => {
            console.error("Error adding product to cart:", error);
            this.handleErrorMessage("An unexpected error occurred. Please try again.");
          })
          .finally(() => {
            button.classList.remove("loading");
            button.removeAttribute("aria-disabled");
            if (this.cart && this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }
            this.spinner?.classList.add("hidden");
          });
        };


      if (this.hitOverageLimit && !isSample) {

        this.overageWarning.classList.add("td-product__cta-warning--active");

        this.overageWarning.querySelector(".td-product__cta-warning-close")?.addEventListener("click", () => {
          this.overageWarning.classList.remove("td-product__cta-warning--active");
        });

        const handleOutsideClick = (event) => {
          if (!this.overageWarning.contains(event.target)) {
            this.overageWarning.classList.remove("td-product__cta-warning--active");
            document.removeEventListener("click", handleOutsideClick);
          }
        };
    
        document.addEventListener("click", handleOutsideClick);
    
        const confirmAtcButton = this.overageWarning.querySelector("[data-confirm-atc]");

        confirmAtcButton?.addEventListener("click", (e) => {
          e.preventDefault();

          this.overageWarning.classList.remove("td-product__cta-warning--active");

          this.continueAddToCart();
        });
        return; 
      }

      this.continueAddToCart();
    }

    updateATC() {
      function getVariantPrice(quantityElement) {
        const priceElement = document.querySelector("[data-price-varies-true-min]");
      
        const variantPrice = priceElement 
          ? parseFloat(priceElement.textContent.trim().replace(/[^0-9.]/g, "")) || 0 
          : parseFloat(quantityElement.dataset.variantPrice || 0) / 100;
      
        return variantPrice;
      }

      
      const priceDisplay = this.querySelectorAll(".product-price-display");
      const standardInput = this.querySelector("[data-input-standard]");
      const quantityElement = this.querySelector(".td-quantity-sq-ft");
      const variantPrice = getVariantPrice(quantityElement);
      
      if (!priceDisplay || !quantityElement) return;
    
      const standardQuantity = standardInput ? parseInt(standardInput.value, 10) || 0 : 0;
      const totalQuantity = standardQuantity > 0 ? standardQuantity : this.quantity;
    
      const groutPrice = this.groutCrossSellCheckbox?.checked ? this.totalGroutPrice : 0;
    
      const totalPrice = variantPrice * totalQuantity + groutPrice;

      this.submitButton.classList.remove("td-product__cta--quantity-disabled");

      if (totalPrice === 0) {
        this.submitButton.classList.add("td-product__cta--quantity-disabled");
      }
    
      priceDisplay.forEach((element) => {
       element.innerHTML = this.formatMoney(totalPrice);
      });
    }
    
    
    formatMoney(amount, currency = "$") {
      return `${currency}${amount.toFixed(2)}`;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
    
      // Check for a selected input or dropdown
      let variantId = this.querySelector('[name="id"]:checked')?.value;
    
      if (!variantId) {
        const dropdown = this.querySelector('[name="id"]');
        if (dropdown && dropdown.tagName === "SELECT") {
          variantId = dropdown.value;
        }
      }
    
      // Fallback for custom dataset attribute
      if (!variantId) {
        const productElement = this.querySelector("[data-product-variant-id]");
        if (productElement) {
          variantId = productElement.dataset.productVariantId;
        }
      }
    
      // Handle missing variant selection
      if (!variantId) {
        this.handleErrorMessage("Please select a variant before adding to cart.");
        return;
      }
    
      // Pass the selected variant to the add-to-cart function
      this.handleAddToCart(evt, {
        id: variantId,
        quantity: this.quantity,
        button: this.submitButton,
      });
    }
    

    handleCrossSellAddToCart(evt, crossSellElement) {
      evt.preventDefault();

      const crossSellProductId = crossSellElement.dataset.crossSellId;
      if (!crossSellProductId) return;

      this.handleAddToCart(evt, {
        id: crossSellProductId,
        quantity: 1,
        button: crossSellElement,
      }, true);
    }

    onUpdateTotalBoxes(event) {
      if (event.detail) {
        this.quantity = event.detail.totalBoxes;
        this.groutQuantity = event.detail.groutQuantity;
        this.totalGroutPrice = event.detail.groutPrice;
        this.hitOverageLimit = event.detail.overageLimit;
      }
      this.updateATC();
    }
  }

  customElements.define("td-product-form", TdProductForm);
}
